import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { MenuItem, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

// COMPONENT
import InputTextField from '../../../../../../../component/input/inputTextField';
import FilterSelect from '../../../../../../../component/select/filterSelect';
import { ButtonContained } from '../../../../../../../component/mui-custom/MuiCustom';
import { setLoading, unsetLoading } from '../../../../../../../store/slice/loading/loading.slice';
import { swalError, swalSuccess } from '../../../../../../../component/notification/swal';

// API
import { TacticsApi, createTactics } from '../../../../../../../api/tactics/tactics.api';

type Props = {
    fetchData: () => void;
    toggleModal: () => void;
    idTactics: number;
}

const EditTactics: React.FC<Props> = (props: Props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [tactics, setTactics] = useState<createTactics>({
        idStrategy: 0,
        tacticsDesc: "",
        tacticsName: "",
        tacticsNo: "",
        tacticsStatus: t("STATUS.ACTIVE"),
    })

    // API
    const handleGetDetailTactics = async () => {
        dispatch(setLoading())
        await TacticsApi.getDetail(props.idTactics)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    console.log(res.data?.result)
                    const { idStrategy, tacticsDesc, tacticsName, tacticsNo, tacticsStatus } = res.data?.result
                    setTactics((prev) => ({ ...prev, idStrategy, tacticsDesc, tacticsName, tacticsNo, tacticsStatus }))

                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleSubmit = async (event: React.FormEvent) => {
        dispatch(setLoading())
        event.preventDefault();
        await TacticsApi.updateTactics(props.idTactics, tactics)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                    props.toggleModal()
                    props.fetchData()
                } else {
                    swalError(res.response?.data?.description)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                swalError(error.response?.data?.description)
                console.log(error)
            })
    }

    useEffect(() => {
        handleGetDetailTactics();
    }, [])
    return (
        <form className='w-full' onSubmit={handleSubmit}>
            <div className='flex flex-col w-full mt-8 gap-5'>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setTactics((prev) => ({ ...prev, tacticsNo: e.target.value }))}
                        value={tactics.tacticsNo}
                        heading='ลำดับกลยุทธ์'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setTactics((prev) => ({ ...prev, tacticsName: e.target.value }))}
                        value={tactics.tacticsName}
                        heading='ชื่อกลยุทธ์'
                    />
                </span>
                <span>
                    <InputTextField
                        required
                        onchange={(e: React.ChangeEvent<HTMLInputElement>) => setTactics((prev) => ({ ...prev, tacticsDesc: e.target.value }))}
                        value={tactics.tacticsDesc}
                        heading='คำขยายความกลยุทธ์'
                    />
                </span>
                <span>
                    <FilterSelect
                        required
                        heading={t("สถานะกลยุทธ์")}
                        renderValue={() => tactics.tacticsStatus === t("STATUS.ACTIVE") ?
                            <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            : <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>}
                        label={t('STATUS.LABEL')}
                        selectId="select-fiscal-year"
                        value={tactics.tacticsStatus}
                        labelId="label-fiscal-year"
                        onchange={(event: React.ChangeEvent<HTMLSelectElement>) => setTactics((prev) => ({ ...prev, tacticsStatus: event.target.value }))}
                        options={[
                            <MenuItem key="1" value={t("STATUS.ACTIVE")}>
                                <Typography className='text-light_success'> {t("STATUS.ACTIVE")}</Typography>
                            </MenuItem>,
                            <MenuItem key="2" value={t("STATUS.INACTIVE")}>
                                <Typography className='text-danger'>{t('STATUS.INACTIVE')}</Typography>
                            </MenuItem>
                        ]}
                    />
                </span>
                <span className='mt-3 flex justify-center items-center'>
                    <ButtonContained
                        type='submit'
                        sx={{ maxWidth: 105 }}
                    >
                        {t("BUTTON.SUBMIT")}
                    </ButtonContained>
                </span>
            </div>
        </form>
    )
}

export default EditTactics

